import { useMutation } from 'react-query';
import { importedCpfCnpj } from './ImportedCPFCNPJ.service';
import { queryClient } from '@/Root';
import { ImportedCpfCnpjResponse } from './ImportedCPFCNPJ.types';

export function useImportedCpfCnpj() {
  const mutation = useMutation(
    async (cpfcnpj: string) => {
      const cache = queryClient.getQueryData<ImportedCpfCnpjResponse>([
        'imported-cpf-cnpj',
        cpfcnpj,
      ]);

      if (cache) return cache;

      return await importedCpfCnpj(cpfcnpj);
    },
    {
      onSuccess(data, variables) {
        queryClient.setQueryData(['imported-cpf-cnpj', variables], data);
      },
    },
  );

  return mutation;
}
